import { mutationOptions, useMutation } from '@tanstack/react-query';
import {
  processMessageAttachmentUpload,
  transcribeAudio,
} from './whatsapp.service';
import {
  MutationOptionsHook,
  ProcessMessageAttachmentUploadInputData,
  ProcessMessageAttachmentUploadResponse,
  TranscribeAudioResponse,
  TranscribeInputData,
} from './whatsapp.type';

const transcribeAudioMutation = () => {
  return mutationOptions({
    mutationFn: async (data: TranscribeInputData) => transcribeAudio(data),
  });
};

export const useMessageAttachmentAudioTranscription = (
  options?: MutationOptionsHook<TranscribeAudioResponse, TranscribeInputData>,
) => {
  return useMutation({
    ...transcribeAudioMutation(),
    ...options,
  });
};

const processMessageAttachmentUploadMutation = () => {
  return mutationOptions({
    mutationFn: async (data: ProcessMessageAttachmentUploadInputData) =>
      processMessageAttachmentUpload(data),
  });
};

export const useMessageAttachmentUpload = (
  options?: MutationOptionsHook<
    ProcessMessageAttachmentUploadResponse['data'],
    ProcessMessageAttachmentUploadInputData
  >,
) => {
  return useMutation({
    ...processMessageAttachmentUploadMutation(),
    ...options,
  });
};
